import "core-js/modules/es6.regexp.split";
import "core-js/modules/web.dom.iterable";
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
import { getAction, postAction, downloadFile } from '@/api/manage';
import moment from 'moment';
import { querySiteTree, queryUserTreeList } from '@/api/api';
import dayReportMoudle from "./modules/dayReportMoudle.vue";
export default {
  data: function data() {
    return {
      tableArr: [],
      url: '/om/day/report',
      ipagination: {
        current: 1,
        pageSize: 10,
        pageSizeOptions: ['10', '20', '30'],
        showTotal: function showTotal(total, range) {
          return range[0] + '-' + range[1] + ' 共' + total + '条';
        },
        showQuickJumper: true,
        showSizeChanger: true,
        total: 0
      },
      dataSource: [],
      columns: [{
        title: '日报时间',
        dataIndex: 'time',
        key: 'time',
        align: 'center'
      }, {
        title: '数据审核员',
        dataIndex: 'userId_userName',
        key: 'userId_userName',
        align: 'center'
      }, {
        title: '创建时间',
        dataIndex: 'createTime',
        key: 'createTime',
        align: 'center'
      }, {
        title: '操作',
        key: 'action',
        align: 'center',
        scopedSlots: {
          customRender: 'action'
        }
      }],
      visible: false,
      date: '',
      userTree: [],
      siteTree: [],
      userIds: '',
      siteId: [],
      drawerVisible: false,
      reportObj: {},
      queryDate: [],
      summaryVisible: false,
      summaryDate: ''
    };
  },
  components: {
    dayReportMoudle: dayReportMoudle
  },
  mounted: function mounted() {
    this.getOperationList();
    this.getUser();
  },
  watch: {
    userIds: function userIds(value) {
      console.log('value', value);
    },
    siteId: function siteId(value) {
      console.log('value', value);
    },
    drawerVisible: function drawerVisible(value) {
      if (!value) {
        this.reportObj = {};
      }
    },
    visible: function visible(value) {
      if (!value) {
        this.siteId = [];
      }
    }
  },
  methods: {
    // 按钮权限
    getAuth: function getAuth(id) {
      return id == this.$store.getters.userInfo.id;
    },
    onToExport: function onToExport(record) {
      console.log('record', record);
      downloadFile(record.time + record.userId_userName + '日报.pdf', window.domainURL + '/om/day/report/exportPdf?id=' + record.id, {});
    },
    onToSearch: function onToSearch() {
      this.getOperationList();
    },
    getUser: function getUser() {
      var _this = this;

      // 用户
      queryUserTreeList().then(function (res) {
        if (res.success) {
          for (var i = 0; i < res.result.length; i++) {
            var temp = res.result[i];

            _this.userTree.push(temp);
          }
        }
      });
    },
    onDateChange: function onDateChange(value) {
      var arr = [];
      value.forEach(function (item, index) {
        arr.push(item.format('YYYY-MM-DD'));
      });
      this.queryDate = arr;
      console.log('value', arr);
    },
    handleTableChange: function handleTableChange(pagination) {
      console.log(pagination);
      this.ipagination = pagination;
      this.getOperationList();
    },
    onToEdit: function onToEdit(value) {
      console.log('value', value); // this.getUser()

      value.dayReportSiteList.forEach(function (item, index) {
        if (!item.runSituation) {
          item.runSituation = '正常';
        }

        if (!item.deviceStatus) {
          item.deviceStatus = '所有设备正常';
        }
      });
      this.$refs.moudle.drawerVisible = true;
      this.$refs.moudle.detailState = false;
      this.$refs.moudle.showSubmit = true;
      this.$refs.moudle.reportObj = value;
      this.$refs.moudle.tableArr = value.dayReportSiteList;
    },
    onToDetail: function onToDetail(value) {
      console.log('value', value); // this.getUser()

      value.dayReportSiteList.forEach(function (item, index) {
        if (!item.runSituation) {
          item.runSituation = '正常';
        }

        if (!item.deviceStatus) {
          item.deviceStatus = '所有设备正常';
        }
      });
      this.$refs.moudle.drawerVisible = true;
      this.$refs.moudle.detailState = true;
      this.$refs.moudle.showSubmit = true;
      this.$refs.moudle.reportObj = value;
      this.$refs.moudle.tableArr = value.dayReportSiteList;
    },
    handleOk: function handleOk(value) {
      console.log('value', value);
      this.getGenerate();
    },
    handleCancel: function handleCancel() {
      this.visible = false;
    },
    onToAdd: function onToAdd() {
      this.visible = true;
      this.date = moment(new Date());

      if (window.localStorage.getItem('selectedOprationSiteId')) {
        console.log(window.localStorage.getItem('selectedOprationSiteId'));
        this.siteId = window.localStorage.getItem('selectedOprationSiteId').split(',');
      }

      this.getSite();
    },
    summaryReport: function summaryReport() {
      this.summaryVisible = true;
      this.summaryDate = moment(new Date());
    },
    summaryHandleCancel: function summaryHandleCancel() {
      this.summaryVisible = false;
    },
    summaryHandleOk: function summaryHandleOk() {
      var _this2 = this;

      var params = {};
      params.stime = this.summaryDate.format('YYYY-MM-DD');
      getAction('/om/day/report/summaryGenerate', params).then(function (res) {
        if (res.success) {
          _this2.summaryVisible = false;
          res.result.dayReportSiteList.forEach(function (item, index) {
            if (!item.runSituation) {
              item.runSituation = '正常';
            }

            if (!item.deviceStatus) {
              item.deviceStatus = '所有设备正常';
            }
          });
          _this2.$refs.moudle.drawerVisible = true;
          _this2.$refs.moudle.detailState = true;
          _this2.$refs.moudle.showSubmit = false; // params.time = this.summaryDate

          var userInfo = JSON.parse(window.localStorage.getItem('pro__Login_Userinfo'));
          res.result.time = _this2.summaryDate.format('YYYY-MM-DD');
          res.result.userId = userInfo.value.id;
          res.result.userId_userName = userInfo.value.realname;
          _this2.$refs.moudle.reportObj = res.result;
          _this2.$refs.moudle.tableArr = res.result.dayReportSiteList;
        }
      });
    },
    getSite: function getSite() {
      var _this3 = this;

      // 用户
      querySiteTree({
        addrType: 1
      }).then(function (res) {
        if (res.success) {
          for (var i = 0; i < res.result.length; i++) {
            var temp = res.result[i];

            _this3.siteTree.push(temp);
          }
        }
      });
    },
    getOperationList: function getOperationList() {
      var _this4 = this;

      var param = {
        pageNo: this.ipagination.current,
        pageSize: this.ipagination.pageSize,
        column: 'time',
        order: 'desc'
      };

      if (this.queryDate.length > 0) {
        param.stime = this.queryDate[0];
        param.etime = this.queryDate[1];
      }

      if (this.userIds) {
        param.userId = this.userIds;
      }

      getAction(this.url, param).then(function (res) {
        if (res.success) {
          _this4.dataSource = res.result.records;
          _this4.ipagination.total = res.result.total;
        }
      });
    },
    getGenerate: function getGenerate() {
      var _this5 = this;

      var params = {};
      params.stime = this.date.format('YYYY-MM-DD');

      if (this.siteId.length > 0) {
        window.localStorage.setItem('selectedOprationSiteId', this.siteId);
        params.siteIds = this.siteId.join(',');
        this.visible = false;
      } else {
        this.$message.warning('请选择站点');
      } // debugger


      getAction('/om/day/report/generate', params).then(function (res) {
        if (res.success) {
          // debugger
          _this5.tableArr = res.result.dayReportSiteList;

          _this5.onToEdit(res.result);
        }
      });
    }
  }
};